




































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
const StoreYearmonth = namespace("yearmonth");
@Component({
  components: {
    LoadingDialog,
    TextMonthChangePicker
  }
})
export default class SummaryTable extends mixins(AxiosMixin) {
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }
  private summary: object[] = []; //総括表
  private detail: object[] = []; //総括表詳細
  private total: object[] = []; //合計
  private isTrial = window.is_trial;

  //=================================================================
  //マウント
  //=================================================================
  mounted() {
    this.updateData();
  }
  //=================================================================
  //検索
  //=================================================================
  private search() {
    this.updateData();
  }
  //=================================================================
  //データ取得
  //=================================================================
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/summarytable/get",
      {
        yearmonth: this.yearmonth.replace("-", "")
      },
      res => {
        this.summary = res.data.lists;
        this.detail = res.data.detail_lists;
        this.total = res.data.total;
      }
    );
  }
  //=================================================================
  // ダウンロード
  //=================================================================
  private download() {
    const fname = `総括表_${this.yearmonth}.xlsx`;
    this.postJsonBlobRes(
      window.base_url + "/api/office/summarytable/excel",
      {
        summary: this.summary,
        detail: this.detail,
        total: this.total
      },
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }
}
